import axios from "axios";
import { useEffect, useState } from "react";
import { getCurrencyCode } from "../utils";
import { currencySymbolMap } from "./currencySymbolMap";

const endpointURL =
  process.env.NODE_ENV === "production"
    ? "https://api.zorbi.app"
    : "http://localhost:5001/zorbi-staging-1/us-central1/v0_1_4";

type MembershipPrice = {
  weekly?: number | string;
  daily?: number | string;
  annual?: number | string;
  currency: string;
  currencySymbol: string;
};

const getMembershipPrice = async () => {
  const currencyCode = await getCurrencyCode();

  return axios
    .get<{ amount: number; currency: string }>(
      `${endpointURL}/membership/price/${currencyCode}`
    )
    .then((res) => res.data);
};

export const useMembershipPrice = () => {
  const [loading, setLoading] = useState(false);
  const [membershipPrice, setMembershipPrice] = useState<MembershipPrice>();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        // Assumes the API always returns an annual pricing
        const { amount, currency } = await getMembershipPrice();
        setMembershipPrice({
          currency: currency.toUpperCase(),
          weekly: (amount / 100 / 52).toFixed(2),
          daily: (amount / 100 / 356).toFixed(2),
          annual: amount,
          currencySymbol: currencySymbolMap[currency.toUpperCase()],
        });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { data: membershipPrice, loading };
};
